export default "__VITE_ASSET__COf0k_Vy__"